import React from 'react';

import { File } from 'types/policyService';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { IconCheckmark } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { FileNameStyled, SignatureRequestInscriptionStyled, TableCellStyled, TableRowStyled } from './styles';
import { MoreDropdown } from '../MoreDropdown';

interface TableProps {
  fileIndex: number;
  file: File;
}

// Enrollment packet files don't currently show availability tags.
// Add custom logic here if availability rules differ in the future.
// For now, all files are available to users who can access this page.
const FileTableRow: React.FC<TableProps> = observer(({ fileIndex, file }) => {
  return (
    <TableRowStyled>
      <TableCellStyled width="60%">
        <b>{`${fileIndex}. `}</b>
        <FileNameStyled>{file.name}</FileNameStyled>
      </TableCellStyled>
      <TableCellStyled width="30%">
        {file.signatureRequestDate ? (
          <SignatureRequestInscriptionStyled>
            <IconCheckmark width="2.4rem" color={colors.green[600]} />
            <span>{normDateToShortAmericanDate(file.signatureRequestDate)}</span>
          </SignatureRequestInscriptionStyled>
        ) : null}
      </TableCellStyled>
      <TableCellStyled width="10%">
        <MoreDropdown file={file} />
      </TableCellStyled>
    </TableRowStyled>
  );
});

export default FileTableRow;
